// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { useOnePageCheckout } from "@toolkit/Framework/Store/Toolkit/Pages/OnePageCheckout/OnePageCheckoutHooks";
import React, { FC } from "react";

export interface OnePageCheckoutPlaceOrderErrorMessageProps extends WidgetProps {}

export interface OnePageCheckoutPlaceOrderErrorMessageStyles {
    infosBox?: InfosBoxProps;
}

export const onePageCheckoutPlaceOrderErrorMessageStyles: OnePageCheckoutPlaceOrderErrorMessageStyles = {
    infosBox: { type: "error" },
};

const styles = onePageCheckoutPlaceOrderErrorMessageStyles;

const OnePageCheckoutPlaceOrderErrorMessage: FC<OnePageCheckoutPlaceOrderErrorMessageProps> = () => {
    const { placeOrderErrorMessage } = useOnePageCheckout();

    if (!placeOrderErrorMessage) {
        return null;
    }

    return <InfosBox {...styles.infosBox}>{placeOrderErrorMessage}</InfosBox>;
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutPlaceOrderErrorMessage,
    definition: {
        displayName: "Place Order Error Message",
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;
